module.exports = __webpack_public_path__ + "media/2.1_warning2_big_cf1.9e3ba18f.wav";